import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { Col } from "react-flexbox-grid";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import styled from "styled-components";

const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
  width: 100%;

  input {
    padding: 1em 0;
  }

  ${({ theme }) => {
    return theme === "true"
      ? `

      .MuiFormLabel-root, .MuiInputBase-root{
        margin: 0 0.4em;
      }

    .MuiInputBase-root {
      background: #e8eaf6;
      padding: 0.3em 1em !important;
      border-radius: 4px;
      border: 1px solid lightgrey;
    }
  
    label + .MuiInput-formControl {
      margin-top: 13px;
    }
  
    .MuiInput-underline:before {
      display: none;
    }
    `
      : "";
  }}
`;

export const DatePicker = ({
  xs,
  md,
  name,
  error,
  label,
  placeholder,
  defaultValue,
  value,
  theme,
  onChange = () => null,
}) => {
  return (
    <Col md={md} xs={xs}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <StyledKeyboardDatePicker
          theme={theme}
          margin="normal"
          name={name}
          label={label}
          format="MM/dd/yyyy"
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          helperText={error}
          KeyboardButtonProps={{ "aria-label": "change date" }}
        />
      </MuiPickersUtilsProvider>
    </Col>
  );
};
